<h1>{{"navigation.channel" | translate}}</h1>
<div class="container-card d-flex" *ngIf="(videos$ | async)">
  <div *ngFor="let video of (videos$ | async)" class="video-card">
    <app-youtube-video [video]="video"></app-youtube-video>
  </div>
</div>
<div class="footer d-flex">
  <div class="flex-grow-1"></div>
  <a href="https://www.youtube.com/c/Hecht-kontaktlinsenDe" target="_blank">{{'home.channel.seeMore' | translate }}
    <fa-icon [icon]="arrow"></fa-icon>
  </a>
</div>
